import { useRouter } from "next/router";
import { useEffect, useMemo } from "react";
import { MdOutlineStyle, MdPerson, MdStar } from "react-icons/md";

import { signOut } from "../../../../api/users/logout";
import { translationsContent } from "../../../../localization/translations";
import { useAppDispatch } from "../../../../redux/hooks";
import { clearCart } from "../../../../redux/slices/cartSlice";
import { resetRestaurantInfo } from "../../../../redux/slices/restaurantSlice";
import { useLanguage } from "../../../../store/lang.context";
import { useUser } from "../../../../store/user.context";
import { translate } from "../../../../utils/translate";
import AccountMenuCategory from "../../button/AccountMenuCategory";
import SaladLogo from "../../svgs/SaladLogo";
import classes from "./accountMenu.module.scss";

const AccountMenu = () => {
  const dispatch = useAppDispatch();

  const router = useRouter();
  const { setUser } = useUser();
  const { language } = useLanguage();
  const categories = useMemo(
    () => [
      {
        label: `${translate(
          translationsContent,
          "accountHeader1Label",
          language
        )}`,
        path: `${translate(translationsContent, "accountHeader1", language)}`,
        icon: <MdPerson className={classes.icon} />,
      },
      {
        label: `${translate(
          translationsContent,
          "accountHeader2Label",
          language
        )}`,
        path: `${translate(translationsContent, "accountHeader2", language)}`,
        icon: <MdOutlineStyle className={classes.icon} />,
      },
      {
        label: `${translate(
          translationsContent,
          "accountHeader4Label",
          language
        )}`,
        path: `${translate(translationsContent, "accountHeader4", language)}`,
        icon: <MdStar className={classes.icon} />,
      },
      {
        label: `${translate(
          translationsContent,
          "accountHeader5Label",
          language
        )}`,
        path: `${translate(translationsContent, "accountHeader5", language)}`,
        icon: <SaladLogo className={classes.icon2} />,
      },
      {
        label: `${translate(translationsContent, "disconnect", language)}`,
        path: "/",
        onClick: () => {
          setUser(undefined);
          signOut();
          dispatch(clearCart());
          dispatch(resetRestaurantInfo());
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setUser]
  );

  useEffect(() => {}, [categories]);
  return (
    <>
      <h1 className={classes.title}>
        {translate(translationsContent, "myAccountHeader", language)}
      </h1>
      <div className={classes.categoryList}>
        {!!categories &&
          categories.map((category, i) => {
            return (
              <AccountMenuCategory
                key={`account_path_${i}`}
                label={category.label}
                path={category.path}
                // isImage={category.isImage}
                selected={router.pathname == category.path}
                onClick={category.onClick}
              >
                {category.icon}
              </AccountMenuCategory>
            );
          })}
      </div>
    </>
  );
};

export default AccountMenu;
